export default [
  {
    path: '/create-announcement',
    name: 'create-announcement',
    component: () => import('@/views/marketing/announcements/pages/CreateAnnouncement.vue'),
    meta: {
      resource: 'announcement',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Create Announcement',
      breadcrumb: [
        {
          text: 'Announcements',
          to: '/annoucements-list',
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/edit-announcement/:id',
    name: 'edit-announcement',
    component: () => import('@/views/marketing/announcements/pages/CreateAnnouncement.vue'),
    meta: {
      resource: 'announcement',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Edit Announcement',
      breadcrumb: [
        {
          text: 'Announcements',
          to: '/annoucements-list',
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/annoucements-list',
    name: 'annoucements-list',
    component: () => import('@/views/marketing/announcements/pages/AnnouncementsList.vue'),
    meta: {
      resource: 'announcement',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Announcements List',
      breadcrumb: [
        {
          text: 'Announcements',
          active: true,
        },
      ],
      allowedCountries: ['LY'],
    },
  },
]
